import React from 'react';
import { Anchor, Heading, Text } from 'wt-ui';
import { Trans } from 'react-i18next';
import i18next from '../../translations/i18n';
import API from '../../services/API';

const Header = () => (
  <>
    <Heading level={1} secondary uppercase>
      <Trans>Short and Leveraged Smart FAQ</Trans>
    </Heading>

    <Text color="#333">{i18next.t('ToolDescription')}</Text>
    <br />
    <Text style={{ marginTop: '15px', display: 'block' }} color="#333">
      <Trans i18nKey="helpText">
        If your question is not answered, please refer to our
        <Anchor href={API.getContactUrl()} primary weight="600" target="_blank">
          &nbsp;contact us
        </Anchor>{' '}
        page.
      </Trans>
    </Text>
  </>
);

export default Header;
